import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ds-pagination",
  templateUrl: "./ds-pagination.component.html",
  styleUrls: ["./ds-pagination.component.scss"],
})
export class DsPaginationComponent {
  @Input() length = 0;
  @Input() pageSize = 10;
  @Input() pageSizeOptions: number[] = [5, 10, 25, 100];
  @Input() pageIndex = 0;
  @Input() showFirstLastButtons = false;
  @Input() disabled = false;
  @Output() pageChange = new EventEmitter<{ pageIndex: number; pageSize: number }>();

  constructor() {}

  get totalPages(): number {
    return Math.ceil(this.length / this.pageSize);
  }

  setPage(index: number) {
    if (index >= 0 && index < this.totalPages) {
      this.pageIndex = index;
      this.emitChange();
    }
  }

  changePageSize(size: number) {
    this.pageSize = +size;
    this.pageIndex = 0;
    this.emitChange();
  }

  private emitChange() {
    this.pageChange.emit({ pageIndex: this.pageIndex, pageSize: this.pageSize });
  }

  pagesToShow(): number[] {
    const total = this.totalPages;
    const current = this.pageIndex;
    const pages: number[] = [];

    if (total <= 4) {
      for (let i = 0; i < total; i++) pages.push(i);
    } else {
      if (current <= 2) {
        pages.push(0, 1, 2, 3);
        if (total > 4) pages.push(-1);
      } else if (current >= total - 3) {
        if (total > 4) pages.push(-1);
        pages.push(total - 4, total - 3, total - 2, total - 1);
      } else {
        pages.push(-1);
        pages.push(current - 1, current, current + 1, current + 2);
        pages.push(-1);
      }
    }
    return pages;
  }
}
